// src/components/Navbar.js
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

function Navbar() {
  const navigate = useNavigate();
  const { access, logout } = useAuthStore();
  const isAuthenticated = !!access;

  const handleLogout = () => {
    logout(); // clears access, refresh, orgId from Zustand storage
    navigate('/');
  };

  return (
    <nav className="bg-gray-100 shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex space-x-6">
          <Link
            to="/dashboard"
            className="text-gray-800 hover:text-blue-600 font-medium transition duration-200"
          >
            Dashboard
          </Link>
          <Link
            to="/departments"
            className="text-gray-800 hover:text-blue-600 font-medium transition duration-200"
          >
            Departments
          </Link>
          <Link
            to="/employees"
            className="text-gray-800 hover:text-blue-600 font-medium transition duration-200"
          >
            Employees
          </Link>
        </div>
        {isAuthenticated && (
          <button
            onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600"
          >
            Logout
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
